import { ClientError } from '../ClientError';
import { GQLPlugin } from '../GQLTypes';

export const ErrorHandlingPlugin: GQLPlugin = ({ onClientError }, { store }) => {
  onClientError.push(error => {
    if (error instanceof ClientError) {
      const { response } = error;
      response.errors &&
        response.errors.forEach(({ message }) => {
          store.commit('setFlash', {
            type: 'error',
            message,
          });
          if (message.includes('403')) store.dispatch('logout');
        });
    }
    throw error;
  });
};
